import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "hotel_order_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "预定人信息", -1);

const _hoisted_7 = {
  class: "base_details_content_second"
};
const _hoisted_8 = {
  key: 0,
  class: "base_details_title"
};
const _hoisted_9 = {
  key: 1,
  class: "base_details_content_second"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "酒店信息", -1);

const _hoisted_11 = {
  class: "base_details_content_second"
};
const _hoisted_12 = ["src"];

const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "优惠信息", -1);

const _hoisted_14 = {
  class: "base_details_content_second"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  key: 2
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "-", -1);

const _hoisted_19 = {
  key: 2,
  class: "base_details_title"
};
const _hoisted_20 = {
  key: 3,
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref } from "vue";
import { $msg, $box } from "@ui/msg";
import useRoute from "@util/router";
import CancelOrder from "@com/order/CancelOrder.vue";
import CancelAfterSale from "@com/order/CancelAfterSale.vue";
import ConfirmAfterSale from "@com/order/ConfirmAfterSale.vue";
import $ from "@util/base";
import api from "@api/order";
import afterApi from "@api/afterSaleOrder";
export default {
  __name: 'HotelOrderDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    const typeKey = urlQuery.type;
    var readOnly = false;
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
      }
    });
    const data = ref({
      orderItem: {},
      // 订单信息
      guestItemList: [{}],
      // 预订人信息
      roomList: [],
      // 房型列表(酒店信息)
      promotionList: [],
      // 优惠列表
      afterSaleItem: {} // 售后信息

    });
    const expenseAftersale = ref(null);
    const refundMoney = ref(null);
    const depositMoney = ref(null);
    getData();

    function getData() {
      api.detail('hotel', urlQuery.code, urlQuery.afterSaleCode, val => {
        if ($.isNotEmpty(val.afterSaleItems)) {
          val.afterSaleItem = val.afterSaleItems[0];
          refundMoney.value = val.afterSaleItem.refundMoney;
          depositMoney.value = val.afterSaleItem.depositMoney;
        }

        expenseAftersale.value = val.orderItem.expenseAftersale;
        data.value = val;
        statusTitle.value = val.orderItem.status; // getConfig(val.orderItem.status)
      });
    }

    let statusTitle = ref("已完成"); // 1023001 未付款 1023002 处理中 1023003 已取消 1023004 待入住 1023005 已完成
    // function getConfig(status) {
    //   switch (status) {
    //     case "1023001":
    //       statusTitle.value = "未付款"
    //       break
    //     case "1023002":
    //       statusTitle.value = "处理中"
    //       break
    //     case "1023003":
    //       statusTitle.value = "已取消"
    //       break
    //     case "1023004":
    //       statusTitle.value = "待入住"
    //       break
    //     case "1023005":
    //       statusTitle.value = "已完成"
    //       break
    //   }
    // }

    function acceptOrder() {
      $box.open("二次已确认", "是否二次已确认？", () => {
        api.confirm('hotel', urlQuery.code, () => {
          $msg.succ("二次已确认成功");
          getData();
        }, msg => {
          $box.open("二次已确认失败", msg);
        });
      });
    }

    const cancelOrderRef = ref("");

    function cancelOrder() {
      cancelOrderRef.value.show();
    }

    function getCancelOrder(data) {
      api.cancel({
        type: 'hotel',
        code: urlQuery.code,
        // amount: data.amount,
        remark: data.reason
      }, () => {
        $msg.succ("取消成功");
        getData();
      });
    }

    function confirmAfterSale() {
      confirmAfterSaleRef.value.show();
    }

    function confirmAfterSaleSubmit(money, deposit) {
      afterApi.confirm(data.value.afterSaleItem.afterSaleCode, money, deposit, () => {
        $msg.succ("退款成功");
        getData();
      });
    }

    const cancelAfterSaleRef = ref(null);
    const confirmAfterSaleRef = ref(null);

    function cancelAfterSale() {
      cancelAfterSaleRef.value.show();
    }

    function getCancelAfterSale(data) {
      afterApi.cancel({
        afterSaleCode: data.value.afterSaleItem.afterSaleCode,
        remark: data.reason
      }, () => {
        $msg.succ("取消成功");
        getData();
      });
    }

    function confirmTakeOver() {
      $box.alert("确认收货", `<div>确定已收到退货商品？</div><div>${data.value.afterSaleItem.expressName}：${data.value.afterSaleItem.expressNo}</div>`, () => {
        afterApi.takeOver(data.value.afterSaleItem.afterSaleCode, () => {
          $msg.succ("确定收货成功");
          getData();
        });
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

      const _component_el_descriptions = _resolveComponent("el-descriptions");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_unref(typeKey) === 'after' ? (_openBlock(), _createBlock(BackTitleView, {
          key: 0,
          title: `售后详情-${data.value.afterSaleItem.afterSaleStatusName}`
        }, null, 8, ["title"])) : (_openBlock(), _createBlock(BackTitleView, {
          key: 1,
          title: `订单详情-${data.value.orderItem.status}`
        }, null, 8, ["title"])), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "订单编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.orderCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "归属基地："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.shopName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "下单时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.createTime), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "付款时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.payTime), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "活动优惠："
            }, {
              default: _withCtx(() => [_createTextVNode("-¥" + _toDisplayString(data.value.orderItem.discountMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "储值支付："
            }, {
              default: _withCtx(() => [_createTextVNode("-¥" + _toDisplayString(data.value.orderItem.depositMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "积分兑换："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.integral), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "实付金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.orderItem.dueMoney), 1)]),
              _: 1
            }), data.value.orderItem.agentMemberName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "分销员："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.agentMemberName), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "入住人数："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.persionNum), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "入住日期："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.guestItemList[0].arriveDate), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "离店日期："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.guestItemList[0].departureDate), 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_table, {
            data: data.value.guestItemList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "预订人",
              prop: "guestName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "联系电话",
              prop: "phoneNumber",
              align: "center"
            })]),
            _: 1
          }, 8, ["data"])]), _unref(statusTitle) == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "取消原因")) : _createCommentVNode("", true), _unref(statusTitle) == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(data.value.cancelReason), 1)) : _createCommentVNode("", true), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_table, {
            data: data.value.roomList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "酒店图片",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("img", {
                src: scope.row.mainPic,
                style: {
                  width: '75px',
                  height: '75px'
                }
              }, null, 8, _hoisted_12)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "酒店名称",
              prop: "hotelName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "酒店编码",
              prop: "hotelCode",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "房型",
              prop: "roomCode",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "价格",
              prop: "duePrice",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "入住天数",
              prop: "dayNum",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "小计",
              prop: "totalMoney",
              align: "center"
            })]),
            _: 1
          }, 8, ["data"])]), _hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_table, {
            data: data.value.promotionList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "优惠名称",
              prop: "promotionName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "优惠金额",
              prop: "promotionMoney",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "优惠类型",
              align: "center"
            }, {
              default: _withCtx(scope => [scope.row.promotionType == '1020001' ? (_openBlock(), _createElementBlock("span", _hoisted_15, "优惠券")) : scope.row.promotionType == '1020002' ? (_openBlock(), _createElementBlock("span", _hoisted_16, "综合活动兑换")) : scope.row.promotionType == '1020003' ? (_openBlock(), _createElementBlock("span", _hoisted_17, "优惠活动")) : _createCommentVNode("", true), _hoisted_18]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]), _unref(typeKey) === 'after' ? (_openBlock(), _createElementBlock("div", _hoisted_19, "售后信息")) : _createCommentVNode("", true), _unref(typeKey) === 'after' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "售后编码："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "订单业务类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.mainBusiTypeName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleTypeName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后状态："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleStatusName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后原因类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.reasonType), 1)]),
              _: 1
            }), data.value.afterSaleItem.reasonDesc ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "售后原因详情："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.reasonDesc), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "会员编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.memberCode), 1)]),
              _: 1
            }), data.value.afterSaleItem.cancelInfo ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 1,
              label: "售后取消原因："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.cancelInfo), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "退款金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.afterSaleItem.refundMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "退还储值金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.afterSaleItem.depositMoney), 1)]),
              _: 1
            }), data.value.afterSaleItem.expressName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 2,
              label: "退回快递公司："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.expressName), 1)]),
              _: 1
            })) : _createCommentVNode("", true), data.value.afterSaleItem.expressNo ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 3,
              label: "退回快递单号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.expressNo), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "创建时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.createTime), 1)]),
              _: 1
            }), data.value.afterSaleItem.updateTime ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 4,
              label: "更新时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.updateTime), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })])) : _createCommentVNode("", true)])])]),
          _: 1
        }), _unref(typeKey) === 'after' ? (_openBlock(), _createBlock(_component_el_footer, {
          key: 2
        }, {
          default: _withCtx(() => [data.value.afterSaleItem.afterSaleStatus === '1052001' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: confirmAfterSale,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("确认退款")]),
            _: 1
          })) : _createCommentVNode("", true), data.value.afterSaleItem.afterSaleStatus === '1052001' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelAfterSale,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("取消售后")]),
            _: 1
          })) : _createCommentVNode("", true), data.value.afterSaleItem.afterSaleStatus === '1052005' || data.value.afterSaleItem.afterSaleStatus === '1052006' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: confirmTakeOver,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("确认收货")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_footer, {
          key: 3
        }, {
          default: _withCtx(() => [!_unref(readOnly) && _unref(statusTitle) == '处理中' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: acceptOrder,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("二次已确认")]),
            _: 1
          })) : _createCommentVNode("", true), !_unref(readOnly) && (_unref(statusTitle) == '处理中' || _unref(statusTitle) == '未付款') ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelOrder
          }, {
            default: _withCtx(() => [_createTextVNode("取消订单")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(CancelOrder, {
        ref_key: "cancelOrderRef",
        ref: cancelOrderRef,
        onCancelOrder: getCancelOrder
      }, null, 512), _createVNode(CancelAfterSale, {
        ref_key: "cancelAfterSaleRef",
        ref: cancelAfterSaleRef,
        onCancelAfterSale: getCancelAfterSale
      }, null, 512), _createVNode(ConfirmAfterSale, {
        ref_key: "confirmAfterSaleRef",
        ref: confirmAfterSaleRef,
        desc: expenseAftersale.value,
        money: refundMoney.value,
        deposit: depositMoney.value,
        onSubmit: confirmAfterSaleSubmit
      }, null, 8, ["desc", "money", "deposit"])]);
    };
  }

};